import { CSSProperties } from 'react';

type StyleMap = { [name: string]: string };

export type TransitionType =
  | 'fadeIn'
  | 'moveIn'
  | 'expand'
  | 'scaleUp'
  | 'fadeOut'
  | 'moveOut'
  | 'collapse'
  | 'scaleDown';

export type TransitionStatusType = {
  entering?: CSSProperties;
  entered?: CSSProperties;
  exiting?: CSSProperties;
  exited?: CSSProperties;
  unmounted?: CSSProperties;
};

export type TransitionStyles = {
  move: TransitionStatusType;
  fade: TransitionStatusType;
  scale: TransitionStatusType;
  toggle: TransitionStatusType;
};

export const dataHooks = {
  fadeStyles: 'fadeStyles',
  moveStyles: 'moveStyles',
  toggleStyles: 'toggleStyles',
  scaleStyles: 'scaleStyles',
  transition: 'transition',
};

export const easingMap: StyleMap = {
  standardEasing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  enterEasing: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  exitEasing: 'cubic-bezier(0.4, 0.0, 1, 1)',
};

export const timingMap: { [name: string]: number } = {
  short: 100,
  medium: 150,
  long: 200,
  fast01: 100,
  fast02: 150,
  medium01: 200,
  medium02: 300,
  slow01: 450,
  slow02: 600,
};
